const links = [
    {
        href: 'tel:+441934744171',
        title: 'Call Onward Travel Solutions',
        label: '01934 744171',
    },
    {
        href: 'mailto:sales@ots-system.net?subject=OTS Online Enquiry',
        title: 'Email Onward Travel Solutions',
        label: 'sales@ots-system.net',
    },
];

export default function Footer() {
    return (
        <footer className='bg-tertiary dark:bg-neutral-950 border-primary border-t-4'>
            <div className='mx-auto md:p-10 px-5 py-14 w-full max-w-6xl text-center'>
                <div className='flex md:flex-row flex-col md:justify-between gap-14 pb-14 center'>
                    <div className='font-light text-gray-300 text-base md:text-left text-center leading-8'>
                        <h3 className='font-bold text-primary text-xl leading-10'>
                            Address
                        </h3>
                        <address className='not-italic'>
                            <p>Onward Travel Solutions Ltd</p>
                            <p>3 Viking House, Cheddar Business Park</p>
                            <p>Wedmore Rd, Cheddar, BS27 3EB</p>
                        </address>
                    </div>
                    <div className='font-light text-gray-300 text-base text-center md:text-right leading-8'>
                        <h3 className='font-bold text-primary text-xl leading-10'>
                            Contact
                        </h3>
                        <ul className='space-y-2 md:space-y-0'>
                            {links.map(({ href, title, label }) => (
                                <li key={`link-${label}`}>
                                    <a
                                        href={href}
                                        title={title}
                                        className='hover:text-primary underline'
                                    >
                                        {label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <small className='font-light text-gray-300 text-sm leading-0.5'>
                    &copy; Onward Travel Solutions Ltd | 2006 -{' '}
                    {new Date().getFullYear()} | Reg 05704112 |{' '}
                    <a
                        href='/terms-conditions'
                        className='hover:opacity-80 text-primary underline transition'
                        title='View Our Terms & Conditions Privacy Policy'
                    >
                        Privacy Policy
                    </a>
                </small>
            </div>
        </footer>
    );
}
